// ANGULAR
import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
// SERVICES
import { GlobalService } from '@services/global.service';
// MODELS
import { PostStartEditingRequest, ResponseModoEdicion } from '@models/edicion.model';
// RXJS
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class EdicionService {
  readonly httpOptions: { headers: HttpHeaders, params: HttpParams } = { headers: new HttpHeaders({ 'content-type': 'application/json', 'accept': 'application/json' }), params: new HttpParams() };

  constructor(
    private globalService: GlobalService,
    private http: HttpClient
  ) { }

  getModoEdicion(): Observable<ResponseModoEdicion> {
    return this.http.get<ResponseModoEdicion>(`${this.globalService.apiUrl.url}/Edicion/ModoEdicion`, this.httpOptions);
  }

  getEditado(): Observable<boolean> {
    return this.http.get<boolean>(`${this.globalService.apiUrl.url}/Edicion/Editado`, this.httpOptions);
  }

  postStartEditing(postStartEditingRequest: PostStartEditingRequest): Observable<void> {
    return this.http.post<void>(`${this.globalService.apiUrl.url}/Edicion/Inicio`, postStartEditingRequest, this.httpOptions);
  }

  postFinishEditing(acceptChanges: boolean): Observable<void> {
    let params: HttpParams = new HttpParams();
    params = params.set('aceptarCambios', acceptChanges);

    return this.http.post<void>(`${this.globalService.apiUrl.url}/Edicion/Fin`, null, { ...this.httpOptions, params });
  }

  getSegundosIntervaloActualizaciones(): Observable<number> {
    return this.http.get<number>(`${this.globalService.apiUrl.url}/Edicion/SegundosIntervaloActualizaciones`, this.httpOptions);
  }

  putEditSegundosIntervaloActualizaciones(secondsUpdateInterval?: number): Observable<void> {
    let params: HttpParams = new HttpParams();
    if (secondsUpdateInterval) { params = params.set('segundosIntervaloActualizaciones', secondsUpdateInterval); }

    return this.http.put<void>(`${this.globalService.apiUrl.url}/Edicion/SegundosIntervaloActualizaciones`, null, { ...this.httpOptions, params });
  }
}